import React from 'react';
import { Badge, Button } from 'react-bootstrap';

/**
 * CurrentOrgIndicator - Shows currently viewed organization (for superadmins)
 * @param {string} orgName - Name of current organization
 * @param {function} onSwitch - Callback when user wants to switch org
 */
const CurrentOrgIndicator = ({ orgName, onSwitch }) => {
  return (
    <div 
      style={{
        position: 'fixed',
        // top: '70px',
        right: '20px',
        zIndex: 10000,
        backgroundColor: '#fff',
        padding: '10px 15px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        border: '2px solid #1abc9c',
      }}
    >
      <div className="d-flex align-items-center gap-2">
        <Badge bg="success" style={{ backgroundColor: '#1abc9c' }}>
          SUPERADMIN
        </Badge>
        <div>
          <small className="text-muted d-block" style={{ fontSize: '0.75rem' }}>
            Currently viewing:
          </small>
          <strong style={{ fontSize: '0.9rem' }}>{orgName}</strong>
        </div>
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={onSwitch}
          title="Switch organization"
        >
          <i className="fas fa-exchange-alt"></i>
        </Button>
      </div>
    </div>
  );
};

export default CurrentOrgIndicator;